import { QRCodeSVG } from 'qrcode.react';
import type { FormacaoPresenca } from '../types';

interface Props {
  formacao: FormacaoPresenca;
  aoFechar: () => void;
  aoGerarNovo: () => void;
}

export default function ModalQRPresenca({ formacao, aoFechar, aoGerarNovo }: Props) {
  const link = `https://www.seligacatolico.com.br/presenca/${formacao.token_presenca ?? ''}`;

  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center bg-black/40 sm:items-center sm:p-6">
      <div className="animate-modal-pop w-full max-w-sm rounded-t-lg bg-white p-6 sm:rounded-lg">
        <div className="flex items-start justify-between gap-3">
          <h3 className="text-base font-medium text-foreground-950">QR de presença</h3>
          <button
            type="button"
            onClick={aoFechar}
            className="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-md text-secondary-500 transition-colors hover:bg-background-100 hover:text-foreground-800"
            aria-label="Fechar"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </div>

        <p className="mt-1 text-sm text-secondary-500">{formacao.formacao}</p>

        <div className="folha-imprimir mt-5 flex flex-col items-center">
          <div className="rounded-lg border border-secondary-200 bg-white p-4">
            <QRCodeSVG value={link} size={320} level="M" />
          </div>
          <p className="mt-4 break-all text-center text-2xl font-semibold leading-tight tracking-wider text-foreground-950">
            {formacao.token_presenca ?? '—'}
          </p>
          <p className="mt-1 text-center text-xs text-secondary-500">{link}</p>
        </div>

        <div className="nao-imprimir mt-6 flex flex-wrap gap-3">
          <button
            type="button"
            onClick={() => window.print()}
            className="flex-1 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary-600"
          >
            Imprimir
          </button>
          <button
            type="button"
            onClick={aoGerarNovo}
            className="flex-1 cursor-pointer whitespace-nowrap rounded-md border border-secondary-300 bg-white px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
          >
            Gerar QR novo
          </button>
        </div>
      </div>
    </div>
  );
}